import { useMediaQuery } from '@/app/stay/useMediaQuery'
import { useNow } from '@/lib/useNow'

/**
 * Hora (0–23) en la zona horaria de la propiedad. Sin zona (la API actual no la devuelve), la del
 * dispositivo, como el resto de fechas de la app (inventario R13).
 */
export function propertyHour(now: Date, timeZone: string | null): number {
  if (!timeZone) return now.getHours()
  try {
    const hour = new Intl.DateTimeFormat('en-GB', { hour: '2-digit', hourCycle: 'h23', timeZone }).formatToParts(now).find((p) => p.type === 'hour')?.value
    return hour === undefined ? now.getHours() : Number(hour)
  } catch {
    return now.getHours()
  }
}

/** Franja nocturna: de 21:00 a 07:00 en la hora local de la propiedad. */
export const isNightHour = (hour: number) => hour >= 21 || hour < 7

/**
 * Pantalla nocturna de la llave (DESIGN.md §2, inventario D41): oscura si el dispositivo está en modo oscuro
 * o si en la propiedad es de noche (21:00–07:00), lo que ocurra. Solo la superficie de la llave.
 */
export function useNightKey(timeZone: string | null): boolean {
  const dark = useMediaQuery('(prefers-color-scheme: dark)')
  const now = useNow()
  return dark || isNightHour(propertyHour(now, timeZone))
}
